var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"captcha",style:({height: _vm.computeSize}),attrs:{"src":_vm.src},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }